import { currentUser } from "@/App";
import { useQuery } from "@tanstack/react-query";

const API_BASE = process.env.REACT_APP_API_BASE;

const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
};

export const fetchLocations = async () => {
  // assert currentUser is artist
  if (currentUser.role !== "artist") {
    throw new Error("Current user is not an artist");
  }

  const endpoint = new URL(`${API_BASE}/data/map`);
  endpoint.searchParams.set("artist_key", currentUser.key);
  const response = await fetch(endpoint.toString(), { headers });
  const data = await response.json();
  return data;
};

export const useLocations = () => {
  return useQuery({
    queryKey: ["locations"],
    queryFn: fetchLocations,
  });
};

export const fetchActiveSubscribers = async () => {
  const endpoint = new URL(`${API_BASE}/artist/data/active`);
  endpoint.searchParams.set("artist_key", currentUser.key);
  const response = await fetch(endpoint.toString(), { headers });
  const data = await response.json();
  return data;
};

export const useActiveSubscribers = () => {
  return useQuery({
    queryKey: ["active-subscribers"],
    queryFn: fetchActiveSubscribers,
  });
};

export const fetchGender = async () => {
  const endpoint = new URL(`${API_BASE}/data/gender`);
  endpoint.searchParams.set("artist_key", currentUser.key);
  const response = await fetch(endpoint.toString(), { headers });
  const data = await response.json();
  return data;
};

export const useGender = () => {
  return useQuery({
    queryKey: ["gender"],
    queryFn: fetchGender,
  });
};

export const fetchFrontRow = async (limit = 5000) => {
  const endpoint = new URL(`${API_BASE}/data/front-row`);
  endpoint.searchParams.set("artist_key", currentUser.key);
  endpoint.searchParams.set("limit", limit);
  const response = await fetch(endpoint.toString(), { headers });
  const data = await response.json();
  return data;
};

export const useFrontRow = (limit = 5000) => {
  return useQuery({
    queryKey: ["front-row", limit],
    queryFn: () => fetchFrontRow(limit),
  });
};

export const fetchListener = async () => {
  const endpoint = new URL(`${API_BASE}/data/listener`);
  endpoint.searchParams.set("artist_key", currentUser.key);
  const response = await fetch(endpoint.toString(), { headers });
  const data = await response.json();
  return data;
};

export const useListener = () => {
  return useQuery({
    queryKey: ["listener"],
    queryFn: fetchListener,
  });
};

export const fetchSubscriberChange = async () => {
  const endpoint = new URL(`${API_BASE}/data/subscribers_change`);
  endpoint.searchParams.set("artist_key", currentUser.key);
  const response = await fetch(endpoint.toString(), { headers });
  const data = await response.json();
  return data;
};

export const useSubscriberChange = () => {
  return useQuery({
    queryKey: ["subscriber-change"],
    queryFn: fetchSubscriberChange,
  });
};
